formatPaymentMethod